import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Box,
} from '@mui/material';
import {
  PersonSearch as PersonSearchIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  Badge as BadgeIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationOnIcon,
  Notes as NotesIcon,
  Fingerprint as FingerprintIcon,
  Receipt as ReceiptIcon,
  PersonAdd as PersonAddIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../../contexto/store';
import {
  ModificarPosibleCliente,
  eliminarDePosiblesClientes,
  registrarCliente,
} from '../../../actions/ClientesAction';
import { withRouter } from 'react-router-dom';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';
const PerfilPosibleCliente = (props) => {
  const mounted = useRef(true);
  const posiblecliente = props.location.state;
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [idp, setId] = useState('');
  const [cliente, setCliente] = useState({
    NOMBRE: '',
    APELLIDO: '',
    CI: '',
    RUC: '',
    TELEFONO: '',
    DIRECCION: '',
    EMAIL: '',
    USUARIO: '',
    OBSERVACIONES: '',
  });
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setCliente((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const EditarPosibleCliente = () => {
    const objetoNuevo = {
      NOMBRE: cliente.NOMBRE,
      APELLIDO: cliente.APELLIDO,
      CI: cliente.CI,
      RUC: cliente.RUC,
      TELEFONO: cliente.TELEFONO,
      DIRECCION: cliente.DIRECCION,
      EMAIL: cliente.EMAIL,
      OBSERVACIONES: cliente.OBSERVACIONES,
    };
    ModificarPosibleCliente(objetoNuevo, idp).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se modifico con exito el posible cliente ',
          },
        });
        setCliente({
          NOMBRE: '',
          APELLIDO: '',
          CI: '',
          RUC: '',
          TELEFONO: '',
          DIRECCION: '',
          EMAIL: '',
          USUARIO: '',
          OBSERVACIONES: '',
        });
        let objetoAudi = {
          usuario: sesionUsuario.usuario.nombrecompleto,
          accion: 'Modificacion',
          panel: 'Gestion de Clientes',
          tabla: 'POSIBLESCLIENTES',
          filaafectada: props.location.state.posibleclientE_Id,
          UsuarioId: sesionUsuario.usuario.id,
        };
        RegistrarAccion(objetoAudi);
        volver();
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar guardar ',
          },
        });
      }
    });
  };
  const volver = () => {
    props.history.goBack();
  };
  const NuevoClienteRegular = () => {
    let objetoClienteNuevo = {
      NOMBRE: cliente.NOMBRE,
      APELLIDO: cliente.APELLIDO,
      CI: cliente.CI,
      RUC: cliente.RUC,
      PROFESIONORUBRO: cliente.PROFESIONORUBRO,
      HOBBY: cliente.HOBBY,
      OBSERVACIONES: cliente.OBSERVACIONES,
      ENTROCOMOPC: cliente.FECGRA,
    };
    registrarCliente(objetoClienteNuevo).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se guardo exitosamente el Cliente',
          },
        });
        setCliente({
          NOMBRE: '',
          APELLIDO: '',
          CI: '',
          RUC: '',
          TELEFONO: '',
          DIRECCION: '',
          EMAIL: '',
          USUARIO: '',
          OBSERVACIONES: '',
          PROFESIONORUBRO: '',
          HOBBY: '',
        });
        volver();
        eliminarDePosiblesClientes(idp).then((response) => {
          if (response.status === 200) {
            console.log('ELIMINO POSIBLE CLIENTE');
          } else {
            console.log('NO ELIMINO');
          }
        });
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje:
              'Errores al intentar guardar Asegurese de llenar todos los campos ',
          },
        });
      }
    });
  };
  useEffect(() => {
    if (mounted.current) {
      setId(posiblecliente.posibleclientE_Id);
      setCliente({
        NOMBRE: posiblecliente.nombre,
        APELLIDO: posiblecliente.apellido,
        CI: posiblecliente.ci,
        RUC: posiblecliente.ruc,
        TELEFONO: posiblecliente.telefono,
        DIRECCION: posiblecliente.direccion,
        EMAIL: posiblecliente.email,
        PROFESIONORUBRO: posiblecliente.profesionorubro,
        HOBBY: posiblecliente.hobby,
        OBSERVACIONES: posiblecliente.observaciones,
        USUARIO: posiblecliente.usuario,
        FECGRA: posiblecliente.fecgra,
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [posiblecliente]);
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <PersonSearchIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Editar Posible Cliente
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Modifica la información o conviértelo en cliente regular
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Información Principal */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Información del Posible Cliente
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              name="NOMBRE"
              value={cliente.NOMBRE}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nombre"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="APELLIDO"
              value={cliente.APELLIDO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Apellido/Razón Social"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="CI"
              value={cliente.CI}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nro. Cédula"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <FingerprintIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="RUC"
              value={cliente.RUC}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="RUC"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <ReceiptIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="TELEFONO"
              value={cliente.TELEFONO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Teléfono"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <PhoneIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="DIRECCION"
              value={cliente.DIRECCION}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Dirección"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <LocationOnIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="EMAIL"
              value={cliente.EMAIL}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Email"
              type="email"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <EmailIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="OBSERVACIONES"
              value={cliente.OBSERVACIONES}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              label="Observaciones"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'flex-start', pt: 1.5 }}>
                    <NotesIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Botones de acción */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
        }}
      >
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={volver}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-2px)',
              boxShadow: 2,
            },
            transition: 'all 0.2s ease',
          }}
        >
          Volver
        </Button>

        <Button
          variant="contained"
          size="large"
          startIcon={<SaveIcon />}
          onClick={EditarPosibleCliente}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Guardar Cambios
        </Button>

        <Button
          variant="contained"
          size="large"
          startIcon={<PersonAddIcon />}
          onClick={NuevoClienteRegular}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            backgroundColor: '#2e7d32',
            '&:hover': {
              backgroundColor: '#1b5e20',
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Pasar a Cliente Regular
        </Button>
      </Box>
    </Container>
  );
};
export default withRouter(PerfilPosibleCliente);
